<template>
  <div class="container" v-if="pageLoaded">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-l">
            Escolha um cartão para ser a sua nova forma de pagamento
          </div>

          <alert-box ref="alertBox" class="spacer-bottom-l" />

          <card-list :cards="creditCards" @cardSelected="selectCard" @cardRemoved="loadCards" />

          <router-link
            tag="button"
            :to="{ name: 'cpm-new-credit-card'}"
            class="z-button z-button--secondary z-button--block"
          >
            Adicionar novo cartão de crédito
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import CardList from 'components/card-list';
import RecurrentPaymentMethodService from 'services/RecurrentPaymentMethodService';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    CardList,
  },
  data() {
    return {
      pageLoaded: false,
      whatsappNumber: '0800 291 7878',
    };
  },
  computed: {
    ...mapState([
      'studentCards',
      'currentBilling',
    ]),
    creditCards() {
      return this.studentCards.filter((card) => card.card_type === 'credit_card');
    },
  },
  methods: {
    ...mapActions(['loadStudentCards']),
    selectCard(card) {
      this.$tracker.logEvent('[change payment method] Selected Credit Card');
      this.$pageLoader.wrap(this.updatePaymentMethod(card), 'Salvando forma de pagamento.');
    },
    updatePaymentMethod(card) {
      return RecurrentPaymentMethodService.enableCreditCard(this.currentBilling.id, card.id)
        .then(() => {
          this.$router.push({ name: 'cpm-success' });
        })
        .catch(() => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            `Houve um problema ao configurar a forma de pagamento. \
            Por favor, entre em contato com o Quero Pago pelo Whatsapp: ${this.whatsappNumber}`,
          );
        });
    },
    loadCards() {
      this.loadStudentCards().then(() => {
        if (this.creditCards.length === 0) {
          this.$router.push({ name: 'cpm-new-credit-card' });
        } else {
          this.pageLoaded = true;
        }
      });
    },
  },
  created() {
    this.loadCards();
  },
};
</script>
